export default "__VITE_ASSET__BaKqN0g5__"